if (!customElements.get('sr-pdp-fit-details')) {
  const VW_SELECTORS = [
    '.vw-cmp__in-video-card--preview',
    '.vw-cmp__in-video-card--thumb',
    '.vw-cmp__in-video-card--root',
  ];
  const VW_TIMEOUT_MS = 20000;
  const VW_POLL_MS = 120;

  customElements.define(
    'sr-pdp-fit-details',
    class SrPdpFitDetails extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.signal = this.abortController.signal;
        this.vwReady = false;

        this.querySelectorAll('[data-sr-size-guide]').forEach((button) => {
          button.addEventListener('click', this.openSizeGuide.bind(this), { signal: this.signal });
        });

        this.bindVideowise();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        window.clearTimeout(this.vwTimer);
        this.vwBound = false;
        this.sizeGuideIntervals?.forEach((interval) => window.clearInterval(interval));
        this.releaseVideowiseRoot();
      }

      openSizeGuide(event) {
        event.preventDefault();

        const openKiwi = () => {
          const kiwiTrigger = document.querySelector('.ks-chart-modal-link');
          if (!kiwiTrigger) return false;

          kiwiTrigger.click();
          return true;
        };

        if (openKiwi()) return;

        let attempts = 0;
        this.sizeGuideIntervals = this.sizeGuideIntervals || new Set();
        const interval = window.setInterval(() => {
          attempts += 1;
          if (openKiwi() || attempts > 20) {
            window.clearInterval(interval);
            this.sizeGuideIntervals.delete(interval);
          }
        }, 150);
        this.sizeGuideIntervals.add(interval);
      }

      bindVideowise() {
        if (this.vwBound) return;

        const card = this.querySelector('[data-sr-vw]');
        if (!card) return;

        const widgetId = card.getAttribute('data-vw-widget');
        const host = card.querySelector('[data-sr-vw-host]');
        if (!widgetId || !host) return;

        const hostId = 'reeview-app-widget_' + widgetId;
        const hosts = document.querySelectorAll('[id="' + hostId + '"]');
        if (hosts.length > 1 && hosts[0] !== host) {
          host.removeAttribute('id');
          return;
        }

        this.vwBound = true;
        this.vwWidgetId = widgetId;
        this.vwHost = host;

        let root = host.shadowRoot;
        if (!root) {
          try {
            root = host.attachShadow({ mode: 'open' });
          } catch (error) {
            return;
          }
        }

        window.videowiseShadowRoots = window.videowiseShadowRoots || {};
        if (!window.videowiseShadowRoots[widgetId] || window.videowiseShadowRoots[widgetId] === root) {
          window.videowiseShadowRoots[widgetId] = root;
        } else {
          host.removeAttribute('id');
          return;
        }

        this.addEventListener(
          'click',
          (event) => {
            if (!this.vwReady) return;

            const trigger = event.target.closest('[data-sr-vw], [data-sr-vw-trigger]');
            if (!trigger || !this.contains(trigger)) return;
            if (host.contains(event.target)) return;

            event.preventDefault();
            event.stopPropagation();

            const target = this.findVwTarget();
            if (target) target.click();
          },
          { capture: true, signal: this.signal }
        );

        const started = Date.now();
        const poll = () => {
          if (this.signal.aborted) return;

          if (this.findVwTarget()) {
            this.vwReady = true;
            card.hidden = false;
            card.classList.add('is-ready');
            this.classList.add('is-vw-ready');
            return;
          }

          if (Date.now() - started > VW_TIMEOUT_MS) {
            if (!this.querySelector('.sr-pdp-fit-details__media--fallback')) {
              this.querySelector('.sr-pdp-fit-details__fit')?.classList.add('sr-pdp-fit-details__fit--no-media');
            }
            return;
          }

          this.vwTimer = window.setTimeout(poll, VW_POLL_MS);
        };

        poll();
      }

      findVwTarget() {
        const root = this.vwHost?.shadowRoot;
        if (!root) return null;

        for (let index = 0; index < VW_SELECTORS.length; index += 1) {
          const target = root.querySelector(VW_SELECTORS[index]);
          if (target) return target;
        }

        return null;
      }

      releaseVideowiseRoot() {
        const roots = window.videowiseShadowRoots;
        if (!roots || !this.vwWidgetId || !this.vwHost) return;
        if (roots[this.vwWidgetId] === this.vwHost.shadowRoot) {
          delete roots[this.vwWidgetId];
        }
      }
    }
  );
}
